import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=3d7e6d13&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=3d7e6d13&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e6d13",
  null
  
)

export default component.exports